import React from 'react';

import Navbar from '../global/Navbar';
import Footer from '../global/Footer';
import Newsletter from '../global/Newsletter';

import HeroPrimary from './HeroPrimary';
import BrandIntroduction from './BrandIntroduction';
import WhatWeBuild from './WhatWeBuild';
import CloseContextGap from './CloseContextGap';
import OssieCTA from './OssieCTA';
import BuilderPositioning from './BuilderPositioning';
import HeroSemanticIntegrated from './HeroSemanticIntegrated';
import EnterpriseAILayers from './EnterpriseAILayers';
import ContentService from './ContentService';
import LifeCycle from './Lifecycle';
import DeliveryBand from '../shared/DeliveryBand';
import ContentGrid from './ContentGrid';
import AIPatch from './AIPatch';
import { PageFlow } from '../shared/SectionSurface';
import PageMeta from '../shared/PageMeta';

function Home() {
  return (
    <div data-home-page className="min-w-0 max-w-full">
      <PageMeta path="/" />
      <BrandIntroduction />
      <Navbar />

      <PageFlow>
      {/* 1. Hero */}
      <HeroPrimary />

      {/* 2. Builders-not-SaaS positioning band */}
      <BuilderPositioning />

      {/* 3. Featured product, Semantic HR */}
      <HeroSemanticIntegrated />

      {/* 4. What We Build */}
      <WhatWeBuild />

      {/* 5. Close the Context Gap */}
      <CloseContextGap />

      {/* 6. Enterprise AI Layers, three-layer architecture */}
      <EnterpriseAILayers />

      {/* 7. Apache Ossie CTA */}
      <OssieCTA />

      {/* 8. Platform/service narrative sections */}
      <div id="nexus">
        {/* Analytics coverage across the stack */}
        <ContentService />

        {/* How we work (foundation → intelligence) */}
        <LifeCycle />

        {/* Agile delivery operating model */}
        <DeliveryBand id="how-we-deliver" compact />

        {/* Offerings across the analytics lifecycle */}
        <ContentGrid />

        {/* Enterprise AI conversational CTA */}
        <AIPatch />
      </div>
      </PageFlow>

      <Newsletter />
      <Footer />
    </div>
  );
}

export default Home;
